import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator,
  Validators
} from '@angular/forms';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => FormFieldComponent),
      multi: true,
    }
  ]
})
export class FormFieldComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() label: string;
  @Input() type: string;
  @Input() placeholder = '';
  @Input() style: any;
  @Input() autocomplete: string;
  @Input() textarea = false;
  @Input() maxLength: number;
  @Input() minLength: number;
  @Input() info = '';

  error: boolean;
  icon = 'close';
  value: string;
  control: AbstractControl;
  constructor() { }

  ngOnInit() {
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  writeValue(obj: any): void {
    this.value = obj;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    this.control = control;
    return undefined;
  }

  registerOnValidatorChange(fn: () => void): void {}


  onChange(event) {
    // get value from text area
    this.value = event.target.value;
    // update the form
    this.propagateChange(this.value);
  }

  private propagateChange = (_: any) => { };

}
